export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_HINT =
  'Mínimo 8 caracteres, com 1 número e 1 letra maiúscula.';

export const validatePassword = (password) => {
  if (!password) {
    return 'Senha é obrigatória.';
  }
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `A senha deve ter pelo menos ${PASSWORD_MIN_LENGTH} caracteres.`;
  }
  if (!/\d/.test(password)) {
    return 'A senha deve conter pelo menos um número.';
  }
  if (!/[A-Z]/.test(password)) {
    return 'A senha deve conter pelo menos uma letra maiúscula.';
  }
  return null;
};

export const getPasswordStrength = (password) => {
  if (!password) {
    return { score: 0, label: '', className: '' };
  }

  let points = 0;
  if (password.length >= 8) points++;
  if (password.length >= 12) points++;
  if (/\d/.test(password)) points++;
  if (/[A-Z]/.test(password)) points++;
  if (/[a-z]/.test(password)) points++;
  if (/[^A-Za-z0-9]/.test(password)) points++;

  if (points <= 2) return { score: 1, label: 'Fraca', className: 'weak' };
  if (points <= 4) return { score: 2, label: 'Média', className: 'medium' };
  return { score: 3, label: 'Forte', className: 'strong' };
};
